<h3 style="padding-left: 23px;">Filter</h3>
<div class="filter-overlay-container">
  <div class="filter-row">
    <p class="filter-label">Date sent</p>
    <div class="fd-filter">
      <owc-datepicker size="medium" format="dd-MM-yyyy" variant="outlined" type='range'
        [formControl]="dateSent_startDate">
      </owc-datepicker>
    </div>
  </div>
  <div class="filter-row">
    <p class="filter-label">Date delivered</p>
    <div class="fd-filter">
      <owc-datepicker size="medium" variant="outlined" format="dd-MM-yyyy" type='range'
        [formControl]="feedbackReceived_startdate">
      </owc-datepicker>
    </div>
  </div>
  <div class="filter-row">
    <p class="filter-label">Date read</p>
    <div class="fd-filter">
      <owc-datepicker size="medium" variant="outlined" type='range' format="dd-MM-yyyy"
        [formControl]="dateRead_startDate">
      </owc-datepicker>
    </div>
  </div>
  <div class="filter-row">
    <p class="filter-label">Feedback received</p>
    <div class="fd-filter">
      <owc-datepicker size="medium" variant="outlined" type='range' format="dd-MM-yyyy"
        [formControl]="dateDelivered_startDate">
      </owc-datepicker>
    </div>
  </div>
  <div class="filter-row">
    <p class="filter-label">Status</p>
    <div class="fd-filter">
      <owc-select-dropdown class="fd-status" [formControl]="statusFormControl" [placeholder]="'Select status'"
        variant="outlined">
        <owc-list-item *ngFor="let item of statusList" [value]="item.label">
          {{ item.label }}</owc-list-item>
      </owc-select-dropdown>
    </div>
  </div>
</div>
<div class="filter-overlay-action">
  <div class="ad-button-row">
    <div class="button-left">
      <owc-button style="margin-left: 23px;" (click)="clearForm()">Clear all</owc-button>
    </div>
    <div class="button-right">
      <owc-button class="fd-cancel" style="float: right;" (click)="cancelFilter()">Cancel</owc-button>
      <owc-button color="primary" style="float: right;" class="fd-apply" (click)="applyFilter()">Apply</owc-button>
    </div>
  </div>
</div>